import { FC, TouchEventHandler, useEffect, useState } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.scss';
import { useStopScroll } from '@/common/hooks/useStopScroll';
import CreditCardIcon from '@/common/svg/credit-card-icon.svg';
import CrossIcon from '@/common/svg/cross-icon.svg';
import InfoIcon from '@/common/svg/info-comment-icon.svg';
import Logo from '@/common/svg/logo-neo-credit.svg';
import UserIcon from '@/common/svg/user-icon.svg';
import { CallCenter } from '@/components/CallCenter';
import { LangSwitcher } from '@/components/LangSwitcher';
import { Licence } from '@/components/Licence';
import { Logout } from '@/components/Logout';
import { WorkingTime } from '@/components/WorkingTime';
import { IconButton } from '@/shared/IconButton';
import { ANIMATION_DURATION_STANDARD } from '@/styles/constantsJS';

interface DrawerProps {
  toggle: boolean;
  toggleHandler: () => void;
}

const DRAWER_ID = 'drawer';

const Drawer: FC<DrawerProps> = ({ toggle, toggleHandler }) => {
  const token = localStorage.getItem('token');
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (toggle) {
      setTimeout(() => setIsVisible(true));
    }
  }, [toggle]);

  const closeHandler = () => {
    setIsVisible(false);
    setTimeout(() => toggleHandler(), ANIMATION_DURATION_STANDARD);
  };

  const handleOutClick: TouchEventHandler<HTMLElement> = (event) => {
    const target = event.target as HTMLElement;
    if (!target.closest(`#${DRAWER_ID}`)) {
      closeHandler();
    }
  };

  const onLinkClick = () => {
    closeHandler();
  };

  useStopScroll(isVisible);

  return (
    <aside
      onTouchEnd={handleOutClick}
      className={cn(styles.drawer, { [styles.visible]: isVisible })}
    >
      <div id={DRAWER_ID} className={styles.mobileMenu}>
        <div className={styles.header}>
          <LangSwitcher />
          <div className={styles.logo}>
            <Logo />
          </div>
          <IconButton
            id="drawer-close"
            Icon={CrossIcon}
            onClick={closeHandler}
          />
        </div>
        <div className={styles.body}>
          <div className={styles.main}>
            <nav className={styles.navWrapper}>
              <NavLink
                className={styles.link}
                onClick={onLinkClick}
                to="/payments-info"
              >
                <InfoIcon />
                <FormattedMessage defaultMessage="Способы оплаты" />
              </NavLink>
              <NavLink
                className={styles.link}
                onClick={onLinkClick}
                to="/payment"
              >
                <CreditCardIcon />
                <FormattedMessage defaultMessage="Внести оплату" />
              </NavLink>
              <NavLink className={styles.link} onClick={onLinkClick} to="/auth">
                <UserIcon />
                <FormattedMessage defaultMessage="Личный кабинет" />
              </NavLink>
            </nav>
            <CallCenter />
          </div>
          <div className={styles.footer}>
            {token && <Logout handler={onLinkClick} />}
            <div className={styles.footerText}>
              <Licence />
              <WorkingTime />
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Drawer;
